import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import {FaInstagram, FaLinkedin} from 'react-icons/fa';
import { 
    FooterContainer, 
    FooterWrap, 
    FooterLinksContainer, 
    FooterLinksWrapper, 
    FooterLinkItems, 
    FooterLinkTitle, 
    FooterLink,
    SocialMedia,
    SocialMediaWrap,
    SocialLogo,
    WebsiteRights,
    SocialIcons,
    SocialIconsLink,
    Footimg
  } from './FooterElements';
  import logo from '../../images/Logo_writing.png';

const Footer = () => {

    const toggleHome = () => {
        scroll.scrollToTop();
      };

  return (
    <FooterContainer>
        <FooterWrap>
            <FooterLinksContainer> 
                <FooterLinksWrapper>
                    <FooterLinkItems>
                        <FooterLinkTitle> About Us </FooterLinkTitle>
                            <FooterLink to="../PrivacyNotice"> Privacy Notice </FooterLink>
                            <FooterLink to="../Disclaimer"> Disclaimer </FooterLink>
                            <FooterLink to="../TermsofService"> Terms of Service </FooterLink>
                    </FooterLinkItems>
                </FooterLinksWrapper> 

                <FooterLinksWrapper>
                    <FooterLinkItems>
                        <FooterLinkTitle> Social Media </FooterLinkTitle>
                            <FooterLink to="https://www.instagram.com/structuralconnections/"> Instagram </FooterLink>
                            <FooterLink to="https://www.linkedin.com/company/structural-connections-ltd/"> Linkedin </FooterLink>
                    </FooterLinkItems>
                </FooterLinksWrapper> 

                <FooterLinksWrapper>
                <FooterLinkItems>
                    <FooterLinkTitle> Contact Us </FooterLinkTitle>
                        <FooterLink to="../ContactUs"> Contact Info</FooterLink>
                </FooterLinkItems>
            </FooterLinksWrapper> 
            </FooterLinksContainer>

            <SocialMedia>
                <SocialMediaWrap>
                <SocialLogo to='/' onClick={toggleHome}> <Footimg src={logo} alt="Logo" /> </SocialLogo>
                <WebsiteRights> Structural Connections © {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                
                    <SocialIcons>

                    <SocialIconsLink href="https://www.instagram.com/structuralconnections/" target="_blank"
                    aria-label="Instagram">
                    <FaInstagram />
                    </SocialIconsLink>

                    <SocialIconsLink href="https://www.linkedin.com/company/structural-connections-ltd/" target="_blank"
                    aria-label="Linkedin">
                    <FaLinkedin />
                    </SocialIconsLink>
                    
                    </SocialIcons>
                </SocialMediaWrap>
            </SocialMedia>

        </FooterWrap>
    </FooterContainer>
  )
}

export default Footer;
